import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { SendAsEmailModalVariant } from '../../../../enums/sendAsEmailModalVariant'
import { useSendAsEmailForm } from '../../contexts/sendAsEmailFormContext'
import { SendAsEmailModalBody } from './elements/SendAsEmailModalBody'
import { SendAsEmailModalFooter } from './elements/SendAsEmailModalFooter'

type SendAsEmailModalComponentProps = ModalProps

export const SendAsEmailModalComponent = (modalProps: SendAsEmailModalComponentProps): ReactElement => {
  const { t } = useTranslation()
  const { isSubmitting, variant } = useSendAsEmailForm()

  const modalTitle =
    variant === SendAsEmailModalVariant.Invoice
      ? t('external_invoices.send_as_email.modal.title.send_document')
      : t('external_invoices.send_as_email.modal.title.send_reminder')

  return (
    <Modal {...modalProps} size="s" closable={!isSubmitting}>
      <Modal.Header title={modalTitle} />
      <SendAsEmailModalBody />
      <SendAsEmailModalFooter id={modalProps.id} />
    </Modal>
  )
}
